var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLinkPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 239,
    height: 72,
    viewBox: "0 0 239 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.914,
    y1: 0.05,
    x2: -0.62,
    y2: 0.261,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 0.5,
    x2: -1.306,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: 0.179,
    x2: -0.092,
    y2: 2.263,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: -0.542,
    x2: 0.238,
    y2: 0.39,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7778",
    "data-name": "Group 7778",
    transform: "translate(0.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1347",
    "data-name": "Rectangle 1347",
    transform: "translate(-0.339 0)",
    stroke: "#a6a6a6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 72,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 238,
    height: 71,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "download_1_",
    "data-name": "download (1)",
    transform: "translate(22.292 12.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M87.171,10.831a5.1,5.1,0,0,1-3.805-1.575,5.363,5.363,0,0,1-1.537-3.843,5.244,5.244,0,0,1,1.537-3.839A5.082,5.082,0,0,1,87.167,0a5.15,5.15,0,0,1,3.805,1.575,5.353,5.353,0,0,1,1.537,3.839,5.365,5.365,0,0,1-1.537,3.839,5.055,5.055,0,0,1-3.8,1.579Zm-45.115,0a5.285,5.285,0,0,1-3.822-1.554,5.219,5.219,0,0,1-1.575-3.86,5.219,5.219,0,0,1,1.575-3.86A5.218,5.218,0,0,1,42.056,0a5.326,5.326,0,0,1,2.134.443,4.316,4.316,0,0,1,1.625,1.161l.1.121L44.784,2.84,44.667,2.7A3.217,3.217,0,0,0,42.04,1.571,3.631,3.631,0,0,0,39.421,2.64a3.734,3.734,0,0,0-1.1,2.782,3.735,3.735,0,0,0,1.1,2.782,3.829,3.829,0,0,0,5.309,0A2.892,2.892,0,0,0,45.5,6.462h-3.63V4.9h5.188l.021.142a5.735,5.735,0,0,1,.075.785,4.7,4.7,0,0,1-1.295,3.467,5.054,5.054,0,0,1-3.8,1.537Zm59.985-.221h-1.6l-4.9-7.84.042,1.412v6.424h-1.6V.226H95.81L95.86.3l4.607,7.385-.042-1.408V.226h1.616V10.609Zm-26.892,0H73.529V1.788H70.718V.225h7.239V1.788H75.146v8.822h0Zm-5.752,0H67.782V.226H69.4Zm-9.085,0H58.7V1.788H55.886V.225h7.239V1.788H60.313Zm-5.451-.017h-6.2V.225h6.2V1.788H50.285V4.636h4.131V6.182H50.285V9.031h4.578Zm29.69-2.41a3.577,3.577,0,0,0,2.619,1.086A3.487,3.487,0,0,0,89.79,8.183a3.76,3.76,0,0,0,1.069-2.765,3.767,3.767,0,0,0-1.065-2.765,3.584,3.584,0,0,0-2.619-1.086,3.471,3.471,0,0,0-2.615,1.086,3.759,3.759,0,0,0-1.069,2.765A3.764,3.764,0,0,0,84.552,8.183Z",
    transform: "translate(15.729 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M81.774,19.945a7.126,7.126,0,1,0,7.147,7.126A7.014,7.014,0,0,0,81.774,19.945Zm0,11.428a4.124,4.124,0,0,1-4.018-4.319,4.029,4.029,0,1,1,8.036,0A4.111,4.111,0,0,1,81.774,31.373ZM66.181,19.945a7.126,7.126,0,1,0,7.147,7.126A7.014,7.014,0,0,0,66.181,19.945Zm0,11.428a4.124,4.124,0,0,1-4.018-4.319,4.029,4.029,0,1,1,8.036,0A4.113,4.113,0,0,1,66.181,31.373ZM47.627,22.121v3.016h7.239a6.357,6.357,0,0,1-1.637,3.8,7.386,7.386,0,0,1-5.585,2.214,8.041,8.041,0,0,1,0-16.081,7.727,7.727,0,0,1,5.451,2.16l2.139-2.139a10.517,10.517,0,0,0-7.573-3.053A11.216,11.216,0,0,0,36.437,23.09,11.2,11.2,0,0,0,47.66,34.147a10.121,10.121,0,0,0,7.723-3.108,10.007,10.007,0,0,0,2.623-7.072,9.317,9.317,0,0,0-.167-1.88H47.622S47.627,22.121,47.627,22.121Zm75.891,2.347a6.621,6.621,0,0,0-6.1-4.54,6.77,6.77,0,0,0-6.717,7.126,6.965,6.965,0,0,0,7.072,7.126,7.073,7.073,0,0,0,5.936-3.162L121.287,29.4a4.052,4.052,0,0,1-3.5,1.971,3.639,3.639,0,0,1-3.463-2.159l9.528-3.947S123.517,24.469,123.517,24.469ZM113.8,26.85a3.911,3.911,0,0,1,3.722-4.152,2.747,2.747,0,0,1,2.644,1.508Zm-7.74,6.9h3.129V12.819h-3.129Zm-5.138-12.226h-.113a4.935,4.935,0,0,0-3.759-1.6,7.126,7.126,0,0,0,0,14.239,4.922,4.922,0,0,0,3.759-1.621h.113V33.57c0,2.719-1.453,4.185-3.8,4.185a3.951,3.951,0,0,1-3.592-2.531l-2.719,1.136a6.8,6.8,0,0,0,6.307,4.206c3.667,0,6.775-2.16,6.775-7.427V20.354h-2.957v1.174h-.017Zm-3.592,9.845a4.086,4.086,0,0,1-3.964-4.3,4.107,4.107,0,0,1,3.964-4.336c2.139,0,3.8,1.842,3.8,4.336A3.956,3.956,0,0,1,97.332,31.373Zm40.833-18.555h-7.481V33.754h3.13V25.826h4.356a6.635,6.635,0,0,0,6.868-6.5,6.642,6.642,0,0,0-6.872-6.512Zm.093,10.083H133.81V15.717h4.449a3.593,3.593,0,1,1,0,7.184Zm19.318-2.995a5.892,5.892,0,0,0-5.585,3.2l2.774,1.153a2.974,2.974,0,0,1,2.848-1.545c1.622,0,3.258.969,3.3,2.7v.221a7.009,7.009,0,0,0-3.258-.8c-3,0-6.032,1.637-6.032,4.707,0,2.811,2.457,4.616,5.192,4.616a4.406,4.406,0,0,0,3.981-2.047h.113v1.621h3.015v-8.02C163.921,21.975,161.147,19.907,157.576,19.907Zm-.393,11.466c-1.023,0-2.455-.5-2.455-1.788,0-1.621,1.788-2.235,3.313-2.235a5.429,5.429,0,0,1,2.848.706A3.767,3.767,0,0,1,157.183,31.373Zm17.74-11.019-3.593,9.081h-.113L167.5,20.354H164.13l5.585,12.694L166.532,40.1h3.258l8.591-19.749h-3.458Zm-28.161,13.4h3.128V12.818h-3.128Z",
    transform: "translate(15.633 5.163)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M.764.934A3.393,3.393,0,0,0,0,3.3V40.335a3.229,3.229,0,0,0,.781,2.343l.129.113L21.662,22.04v-.464L.893.821.764.934Z",
    transform: "translate(0 0.352)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M22.068,24.826l-6.921-6.921v-.484L22.068,10.5l.15.092,8.187,4.653c2.343,1.32,2.343,3.5,0,4.837l-8.187,4.653-.15.092Z",
    transform: "translate(6.499 4.505)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M28.487,22.583l-7.071-7.071L.535,36.393c.764.819,2.047.911,3.479.113L28.486,22.584Z",
    transform: "translate(0.229 6.655)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M28.487,14.9,4.015,1C2.582.185,1.3.3.535,1.117l20.881,20.86L28.488,14.9Z",
    transform: "translate(0.23 0.19)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M28.332,20.355,4.027,34.164c-1.358.781-2.569.727-3.35.017l-.129.129.129.113c.781.706,1.992.764,3.35-.017L28.5,20.505l-.167-.15Z",
    transform: "translate(0.235 8.733)",
    fillRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M28.333,17.688l-8.358,4.745.15.15,8.187-4.653a2.934,2.934,0,0,0,1.75-2.418A3.014,3.014,0,0,1,28.333,17.688Z",
    transform: "translate(8.57 6.655)",
    fillRule: "evenodd",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M4.244,1.249,36.9,19.8a3.078,3.078,0,0,1,1.75,2.176,2.934,2.934,0,0,0-1.75-2.419L4.244,1.007C1.9-.334,0,.785,0,3.463V3.7C0,1.023,1.9-.075,4.244,1.249Z",
    transform: "translate(0 0.188)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLinkPlaystore);
export default __webpack_public_path__ + "static/media/app_link_playstore.ac27ff9fde8960325849e5dbe493f4b5.svg";
export { ForwardRef as ReactComponent };